<form
    (ngSubmit)="onSubmit()"
    [formGroup]="form"
    autocomplete="off"
>
  <div class="row">
    <div class="col-12">
      <div class="card shadow">
        <app-help name="settings.attendance.night_shift_duration"></app-help>
        
        <div class="card-header card-header--padding">
          <div class="row">
            <div class="col-sm-6 text-left my-auto">
              <p class="modal-title font-16 text-dark pt-2 pb-2">
                <span>{{ 'settings.page_title_view_attendance_settings_night_shift_duration' | translate }}</span>
              </p>
            </div>
          </div>
        </div>
        
        <div class="card-body">
          <div class="row">
            <div class="col">
              <label class="control-label">{{ 'settings.use_night_shift_duration' | translate }}</label>
            </div>
            <div class="col-auto text-right align-self-center">
              <div>
                <input data-switch="success" formControlName="company.attendance.use_night_shift_duration" id="company.attendance.use_night_shift_duration" name="company.attendance.use_night_shift_duration" type="checkbox">
                <label for="company.attendance.use_night_shift_duration">&nbsp;</label>
              </div>
            </div>
          </div>
          
          <div [ngbCollapse]="!f['company.attendance.use_night_shift_duration'].value">
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label class="control-label">{{ 'settings.night_hours_from' | translate }}</label>
                  <input (flatpickrClose)="fpHelper.applyAltInputValue($event, false)" [allowInput]="true" [altInput]="true"
                         [disableMobile]="true"
                         [enableTime]="true"
                         [locale]="locale$ | async"
                         [noCalendar]="true"
                         [time24hr]="true"
                         altFormat="H:i"
                         class="form-control"
                         dateFormat="H:i" formControlName="company.attendance.night_hours_from"
                         mwlFlatpickr
                         name="company.attendance.night_hours_from"
                         type="text"
                  >
                </div>
              </div>
            </div>
            
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label class="control-label">{{ 'settings.night_hours_to' | translate }}</label>
                  <input (flatpickrClose)="fpHelper.applyAltInputValue($event, false)" [allowInput]="true" [altInput]="true"
                         [disableMobile]="true"
                         [enableTime]="true"
                         [locale]="locale$ | async"
                         [noCalendar]="true"
                         [time24hr]="true"
                         altFormat="H:i"
                         class="form-control"
                         dateFormat="H:i" formControlName="company.attendance.night_hours_to"
                         mwlFlatpickr
                         name="company.attendance.night_hours_to"
                         type="text"
                  >
                </div>
              </div>
            </div>
          </div>
          
          <div class="row mt-2">
            <div class="col d-flex justify-content-end">
              <button class="btn btn-success">
                <span>{{ 'global.action_save' | translate }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
